function roundToTwoDecimals(amount) {
    return roundToXDecimals(amount, 2);
}
/**
 * We use 6 so that we limit how how much precision we lose when rounding, but the mathjs library is still able to convert to a fraction
 * @param amount amount to round
 * @returns rounded result
 */
function roundToSixDecimals(amount) {
    return roundToXDecimals(amount, 6);
}
function roundToXDecimals(amount, decimals) {
    const n = Math.pow(10, decimals);
    return Math.round(amount * n) / n;
}
function filterFullSiblings(self, siblings) {
    return siblings.filter((sibling) => sibling.alive &&
        sibling._mother &&
        self._father &&
        sibling._mother == self._mother &&
        sibling._father == self._father);
}
function filterMaternalHalfSiblings(self, siblings) {
    return siblings.filter((sibling) => sibling.alive &&
        sibling._mother == self._mother &&
        (!self._father || sibling._father != self._father));
}
function filterPaternalHalfSiblings(self, siblings) {
    return siblings.filter((sibling) => sibling.alive &&
        (!self._mother || sibling._mother != self._mother) &&
        sibling._father == self._father);
}
export default {
    roundToTwoDecimals,
    roundToSixDecimals,
    filterFullSiblings,
    filterMaternalHalfSiblings,
    filterPaternalHalfSiblings,
};
